import { getNamespacedBy } from '@/store/utils'

export const actionTypes = {
  FETCH_CITIES: 'fetchCities'
}

export const globalActions = getNamespacedBy('city', actionTypes)
